import {
  stringLength,
  charAt,
  EventBus,
  EventBusListeners,
  regTest
} from "@zyzgroup/core-common";

export interface DOMParseListeners extends EventBusListeners {
  newline(): void;
  special(text: string): void;
  cdata(text: string): void;
  comment(text: string): void;

  text(text: string): void;

  tag(tagname: string, attrs: Record<string, string>): void;
  "/tag"(tagname: string, attrs: Record<string, string>): void;

  /// 结束
  finish(): void;
}

export class DOMParse extends EventBus<DOMParseListeners> {
  source: string;

  raw = "";
  mode = "text";
  tagname = "";
  nodename = "";
  textchunk = "";
  entity = "";
  quote = "";
  attrs: Record<string, string> = {};

  constructor(sourceString: string) {
    super();
    this.source = sourceString;
  }

  parse() {
    const length = stringLength(this.source);
    if (length === 0) {
      this.emit("finish");
      return;
    }
    let prev;
    let current;
    let next = charAt(this.source, 0);
    for (let i = 1; i < length; i++) {
      prev = current;
      current = next;
      next = charAt(this.source, i);
      this.raw += current;
      if (current) {
        this.step(current, next, prev);
      }
    }
    if (next) {
      this.step(next, undefined, current);
    }
    this.emit("finish");
  }

  step(c: string, n?: string, p?: string) {
    c == "\n" && this.emit("newline");
    this.act(c, n, p);
  }

  act(c: string, n?: string, p?: string) {
    switch (this.mode) {
      case "text":
        switch (c) {
          case "<":
          case "eof":
            this.nodename = "";
            this.attrs = {};
            this.mode = "tag name start";
            this.raw = this.raw.slice(0, -1);
            this.textchunk && this.emit("text", this.textchunk);
            this.raw += c;
            this.textchunk = "";
            break;
          case "&":
            this.mode = "entity";
            this.entity = "";
            break;
          default:
            this.textchunk += c;
            break;
        }
        break;

      case "entity":
        if (regTest("whitespace", c)) {
          this.textchunk += entity2text(this.entity);
          this.mode = "text";
        } else if (c == ";") {
          this.textchunk += entity2text(this.entity + c);
          this.mode = "text";
        } else {
          this.entity += c;
        }
        break;

      case "special":
        if (p == "!" && c == "-" && n == "-") {
          this.mode = "comment start";
          break;
        }
        if (this.textchunk == "[CDATA" && c == "[") {
          this.mode = "cdata";
          this.textchunk = "";
          break;
        }
        if (c == ">" || c == "eof") {
          this.emit("special", this.textchunk);
          this.mode = "text";
          this.textchunk = "";
          break;
        }
        this.textchunk += c;
        break;

      case "cdata":
        if (p == "]" && c == "]" && n == ">") {
          this.mode = "cdata end";
          this.textchunk = this.textchunk.slice(0, -1);
          break;
        }
        if (c == "eof") {
          this.mode = "cdata end";
          this.act(c, n, p);
        }
        this.textchunk += c;
        break;

      case "cdata end":
        this.emit("cdata", this.textchunk);
        this.textchunk = "";
        this.mode = "text";
        break;

      case "comment start":
        if (n == ">" || c == "eof") {
          this.emit("comment", "");
          this.mode = "skip";
        } else {
          this.mode = "comment";
        }
        break;

      case "skip":
        this.mode = "text";
        break;

      case "comment":
        if (c == "-" && p == "-" && n == ">") {
          this.mode = "comment end";
          this.textchunk = this.textchunk.slice(0, -1);
        } else if (c == "eof") {
          this.emit("comment", this.textchunk);
        } else {
          this.textchunk += c;
        }
        break;

      case "comment end":
        this.emit("comment", this.textchunk);
        this.textchunk = "";
        this.mode = "text";
        break;

      case "declaration":
        if (c == "?" && n == ">") {
          this.mode = "declaration end";
          break;
        }
        if (c == "eof") {
          this.emit("comment", this.textchunk);
        }
        this.textchunk += c;
        break;

      case "declaration end":
        this.emit("comment", this.textchunk);
        this.textchunk = "";
        this.mode = "text";
        break;

      case "tag name start":
        if (c == "eof") {
          this.emit("text", "<");
          break;
        }
        if (!regTest("whitespace", c)) {
          this.mode = "tag name";
          if (c == "/") {
            this.mode = "close tag name start";
            break;
          } else if (c == "!") {
            this.mode = "special";
            this.textchunk = "";
            break;
          } else if (c == "?") {
            this.mode = "declaration";
            break;
          }
          this.act(c, n, p);
        }
        break;

      case "close tag name start":
        if (!regTest("whitespace", c)) {
          this.mode = "close tag name";
          this.tagname = "";
          this.nodename = "";
          this.act(c, n, p);
        }
        break;

      case "close tag name":
        if (regTest("whitespace", c)) {
          this.tagname = this.nodename;
        } else
          switch (c) {
            case ">":
              this.emit("/tag", this.tagname || this.nodename, this.attrs);
              this.mode = "text";
              break;
            default:
              !this.tagname && (this.nodename += c);
              break;
          }
        break;

      case "tag name":
        if (regTest("whitespace", c)) {
          this.tagname = this.nodename;
          this.nodename = "";
          this.mode = "attr start";
        } else
          switch (c) {
            case ">":
              this.emit("tag", this.nodename, this.attrs);
              this.mode = "text";
              break;
            case "/":
              this.raw += n;
              this.emit("tag", this.nodename, this.attrs);
              this.emit("/tag", this.nodename, this.attrs);
              this.mode = "skip";
              break;
            default:
              this.nodename += c;
              break;
          }
        break;

      case "attr start":
        if (!regTest("whitespace", c)) {
          this.mode = "attr";
          this.nodename = "";
          this.act(c, n, p);
        }
        break;

      case "attr":
        if (regTest("whitespace", c) || c == "=") {
          this.attrs[this.nodename] = "";
          this.mode = "attr value start";
        } else
          switch (c) {
            case ">":
              if (this.nodename == "/") {
                delete this.attrs["/"];
                this.emit("tag", this.tagname, this.attrs);
                this.emit("/tag", this.tagname, this.attrs);
              } else {
                this.nodename && (this.attrs[this.nodename] = "");
                this.emit("tag", this.tagname, this.attrs);
              }
              this.mode = "text";
              break;
            default:
              this.nodename += c;
              break;
          }
        break;

      case "attr value start":
        if (!regTest("whitespace", c)) {
          this.mode = "attr value";
          this.quote = "";
          if (c == "'" || c == '"') {
            this.quote = c;
            return;
          }
          this.act(c, n, p);
        }
        break;

      case "attr value":
        if (regTest("whitespace", c) && !this.quote) {
          this.mode = "attr start";
        } else if (c == ">" && !this.quote) {
          this.emit("tag", this.tagname, this.attrs);
          this.mode = "text";
        } else
          switch (c) {
            case '"':
            case "'":
              if (this.quote == c && p != "\\") {
                this.mode = "attr start";
              }
              break;
            default:
              this.attrs[this.nodename] += c;
              break;
          }
        break;
    }
  }
}

export default DOMParse;

// &nbsp; &#160;
function entity2text(entity: string) {
  const entities: Record<string, number> = {
    lt: 60,
    "lt;": 60,
    "AMP;": 38,
    AMP: 38,
    "GT;": 62,
    GT: 62,
    "QUOT;": 34,
    QUOT: 34,
    "apos;": 39,
    "bull;": 8226,
    "bullet;": 8226,
    "copy;": 169,
    copy: 169,
    "deg;": 176,
    deg: 176
  };
  let code;
  if (entity.charAt(0) == "#") {
    if (entity.charAt(1).toLowerCase() == "x") {
      code = parseInt(entity.substring(2), 16);
    } else {
      code = parseInt(entity.substring(1), 10);
    }
  } else {
    code = entities[entity];
  }
  return code ? String.fromCharCode(code) : "&" + entity;
}
